import React from "react";
import { IconProps } from "./IconProps";

const InstagramLogoIcon: React.FC<IconProps> = ({
  size,
  thickness,
  ariaLabel,
  color = "currentColor",
}) => {
  switch (`${size}${thickness}`) {
    case "32Reg":
      return (
        <svg
          aria-label={ariaLabel}
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_669_5333)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10 5C7.23858 5 5 7.23858 5 10V22C5 24.7614 7.23858 27 10 27H22C24.7614 27 27 24.7614 27 22V10C27 7.23858 24.7614 5 22 5H10ZM3 10C3 6.13401 6.13401 3 10 3H22C25.866 3 29 6.13401 29 10V22C29 25.866 25.866 29 22 29H10C6.13401 29 3 25.866 3 22V10ZM16 12C13.7909 12 12 13.7909 12 16C12 18.2091 13.7909 20 16 20C18.2091 20 20 18.2091 20 16C20 13.7909 18.2091 12 16 12ZM10 16C10 12.6863 12.6863 10 16 10C19.3137 10 22 12.6863 22 16C22 19.3137 19.3137 22 16 22C12.6863 22 10 19.3137 10 16ZM24 9.5C24 10.3284 23.3284 11 22.5 11C21.6716 11 21 10.3284 21 9.5C21 8.67157 21.6716 8 22.5 8C23.3284 8 24 8.67157 24 9.5Z"
              fill={color}
            />
          </g>
          <defs>
            <clipPath>
              <rect width="32" height="32" fill={color} />
            </clipPath>
          </defs>
        </svg>
      );
    default:
      return null;
  }
};

export default InstagramLogoIcon;
